import { z } from 'zod';
import { optionalUuidString } from '../zod-helpers/index.js';
import { bomChargeCostSchema } from './bom-charge-cost-schema.js';
import { bomItemNameSchema, bomQuantitySchema } from './item-form.js';
import { warehouseLocationGroupIdsSchema } from './warehouse-location-group-ids-schema.js';
export const updateBomItemInputSchema = z.object({
    name: bomItemNameSchema.optional(),
    quantity: bomQuantitySchema.optional(),
    cost: bomChargeCostSchema,
    uomId: optionalUuidString('Invalid UOM selection.').optional().nullable(),
    // WHY: undefined leaves ties untouched like name/quantity/uomId above, but an explicit [] clears them, making the item universal again.
    warehouseLocationGroupIds: warehouseLocationGroupIdsSchema.optional(),
});
//# sourceMappingURL=update-item-input.js.map